import React, { useState } from "react";
import { Button, Nav, Offcanvas } from "react-bootstrap";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { useNavigate, Link } from "react-router-dom";
import MenuRoute from "../../util/MenuRoute";
import './PortalNavbar.css';
import LoadingSpinner from "../../shared/LoadingSpinner";

const PortalNavbar = () => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const homepage = () => {
        window.location.reload(true);
    }
    const logout = () => {
        setIsLoading(true);
        localStorage.clear();
        sessionStorage.clear();
        setTimeout(() => {
            setIsLoading(false);
            return navigate('/auth/login');
        }, 5000);
    }
    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            {[false].map((expand) => (
                <Navbar key={expand} bg="light" expand={expand} className="p-0">
                    <Container fluid>
                        <Navbar.Brand as={Link} to="#" onClick={() => homepage()}><img src={`https://assets.rsabhk.co.id/logo/rsabhk-logo-vedika.png`} width="100%" height="auto" alt="Vedika - RSABHK" /></Navbar.Brand>
                        <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                        <Navbar.Offcanvas
                            id={`offcanvasNavbar-expand-${expand}`}
                            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                            placement="end"
                        >
                            <Offcanvas.Header closeButton>
                                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                                    <img src={`https://assets.rsabhk.co.id/logo/rsabhk-logo-vedika.png`} width="100%" height="auto" alt="Vedika - RSABHK" />
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                {/* <MenuRoute/> */}
                                <Nav className="justify-content-start flex-grow-1 pe-3">
                                    <Nav.Link as={Link} to='/laporan-claim'>Laporan Claim</Nav.Link>
                                </Nav>
                                <Nav className="justify-content-start flex-grow-1 pe-3">
                                    <Nav.Link as={Link} to='/rekap-claim'>Rekap Claim</Nav.Link>
                                </Nav>
                                <Nav className="ms-auto">
                                    <Nav.Link>
                                        <Button className="btn-warning" onClick={logout}>Logout</Button>
                                    </Nav.Link>
                                </Nav>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            ))}
        </React.Fragment>
    );
}
export default PortalNavbar;